<template>
  <div class="main_form">
    <div class="title_box">
      <!-- 操作按钮部分 -->
      <div class="operation_box">
        <el-button @click="addExaminee(0)" v-if="type == 'teacher'">
          <img src="@/assets/button_imgs/tianjia.png" alt="" />添加监考官
        </el-button>
        <el-button @click="addExaminee(1)" v-else>
          <img src="@/assets/button_imgs/tianjia.png" alt="" />添加考生
        </el-button>
        <el-button @click="delectArr()">
          <img src="@/assets/button_imgs/shangchuang.png" alt="" />批量删除
        </el-button>
      </div>
      <!-- 账号搜索 -->
      <div class="search_view">
        <div class="search">
          <el-input
            v-model="input"
            :placeholder="
              type == 'teacher'
                ? '根据监考官姓名或账号搜索'
                : '根据考生姓名或账号搜索'
            "
            type="text"
          ></el-input>
          <el-button @click="searchResult" icon="el-icon-search">
            <!-- <i class="iconfont icon-sousuo"></i> -->
          </el-button>
        </div>
        <el-button @click="reset" icon="el-icon-refresh" class="searchbtn">
          重置
        </el-button>
      </div>
    </div>
    <!-- 表格部分 -->
    <div class="examinee_form" v-loading="loading">
      <p>已选{{ getData.length }}人，科室{{ this.unique() }}个</p>
      <el-table
        ref="tabledata"
        :data="isShow == true ? list_vip : getData"
        style="width: 100%"
        height="710"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @row-click="StepsListRowClick"
        :header-cell-style="{
          'background-color': '#EEEEEE',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column type="selection" width="80"></el-table-column>
        <el-table-column type="index" label="序号"> </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                @click.stop="delectstudent(scope.row, scope.$index)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加考生弹窗 -->
    <Addstudent ref="addstudent" @finallyArr="getfinallyArr" />
    <AddPopup ref="popup" :currentRow="currentRow" :type="type"/>
  </div>
</template>

<script>
import { formColumns, options } from "@/state/candidate";
import Addstudent from "./Addstudent.vue";
import AddPopup from "@/components/progress/AddPopup.vue";

export default {
  data() {
    return {
      input: "", // 搜索
      formColumns: "", // 表头
      options: "", // 查询
      currentRowData: {}, //
      isShow: false, // 用于展示查询列表状态
      multipleSelection: [],
      getData: [], // 表格数据
      currentRow: {}, // 要删除的对象
      list_vip: [], // 用于展示查询数据
      loading:true
    };
  },
  props: ["editData", "type", "formTable"],
  methods: {
    // 添加
    addExaminee(type) {
     if (type == 0) {
        // 添加监考官
        this.$refs.popup.cancel(); // 8.11 清除子组件勾选缓存
        this.$refs.popup.submit();
        this.$refs.popup.dialogVisibleObj.addExamineeShow = true;
      } else {
        // 添加考生
        this.$refs.addstudent.init(this.getData);
      }
    },
    //批量删除
    delectArr() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: `警告，当前还未选择${
            this.type == "teacher" ? "监考官" : "考生"
          }，请选择${this.type == "teacher" ? "监考官" : "考生"}!`,
          type: "warning",
        });
      } else {
        this.$confirm(
          `此操作将批量永久删除${
            this.type == "teacher" ? "监考官" : "考生"
          }, 是否继续?`,
          "温馨提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.getData = this.getData.filter((item) => {
              let istrueindex = this.multipleSelection.findIndex((items) => {
                return items.UserID == item.UserID;
              });
              return istrueindex === -1;
            });
            this.list_vip = this.list_vip.filter((item) => {
              let istrueindex = this.multipleSelection.findIndex((items) => {
                return items.UserID == item.UserID;
              });
              return istrueindex === -1;
            });
            if (this.list_vip.length == 0) {
              this.list_vip = JSON.parse(JSON.stringify(this.getData));
            }
            this.isShow = false; // 展示全部数据
            this.$message({
              type: "success",
              message: "批量删除成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 搜索
    searchResult() {
      let articles_array = JSON.parse(JSON.stringify(this.getData)); // 一进来获取的列表数据
      let searchString = this.input; // input的数据
      if (searchString == "") {
        // 传空值的时候展示全部
        this.isShow = false;
        this.list_vip = articles_array;
      } else {
        this.isShow = true; // 展示查询出来的表格
        searchString = searchString.trim().toLowerCase();
        articles_array = articles_array.filter((item) => {
          return JSON.stringify(item).indexOf(searchString) != -1;
        });
        if (this.list_vip.length == 0) {
          this.$message.error(
            `未找到包含“${this.input}”信息的${
              this.type == "teacher" ? "监考官" : "考生"
            }!`
          );
          this.list_vip = JSON.parse(JSON.stringify(this.getData));
        } else {
          this.list_vip = articles_array;
        }
      }
    },
    // 重置
    reset() {
      this.input = "";
      this.isShow = false;
      this.searchResult();
    },
    // 确定考生名单
    getfinallyArr(row) {
      this.getData = row;
      this.$emit("getExam", this.getData);
    },
    // 去重
    unique() {
      let departArr = this.getData.map((item) => {
        return item.DepartmentName;
      });
      departArr = [...new Set(departArr)];
      return departArr.length;
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    // 单个删除
    delectstudent(row, val) {
      this.$confirm(
        `确认将"${row.RealName}"该${
          this.type == "teacher" ? "监考官" : "考生"
        }移出考试, 是否继续?`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.currentRowData = row;
          let userID = row.UserName; // 根据考试账号去删除
          let index = this.getData.findIndex((zitem) => {
            // 找到对应的索引删除
            return userID == zitem.UserName;
          });
          this.getData.splice(index, 1);
          this.list_vip.splice(val, 1); //删除数据源ID
          this.input = "";
          if (this.list_vip.length == 0) {
            this.$parent.list_vip = JSON.parse(JSON.stringify(this.getData));
          }
          this.$message({
            type: "success",
            message: `${this.type == "teacher" ? "监考官" : "考生"}${
              row.RealName
            }删除成功!`,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });

      // this.currentRow = index;
      // this.currentRowData.index = val;
      // this.$refs.delete.deleteState = 0;
      // this.$refs.delete.batchDelete = true;
    },
  },
  components: {
    Addstudent,
    AddPopup,
  },
  created() {
    if (this.formTable && this.formTable.length > 0) {
      this.formColumns = this.formTable;
    } else {
      this.formColumns = formColumns;
    }
    // if(this.type != 2){
    //   this.loading = false
    // }
    this.options = options;
    setTimeout(() => {
      if (this.editData != "null") {
        // 编辑状态
        this.loading = false
        this.getData = this.editData;
      }else{
        this.loading = false
      }
    }, 500);
    console.log(this.editData);
  },
};
</script>

<style lang="scss" scoped>
.main_form {
  .title_box {
    display: flex;
    justify-content: space-between;
    margin: 24px 16px 24px 24px;
    .search_view {
      display: flex;
      .search {
        display: flex;
        width: 300px;
        height: 40px;
        .el-button {
          width: 40px;
          height: 40px;
          background: #1890ff;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #1890ff !important;
          border-radius: 0px 4px 4px 0px !important;
          i {
            display: inline-block;
          }
        }

        ::v-deep .el-input__inner {
          border-radius: 4px 0px 0px 4px !important;
        }
      }
    }
    .searchbtn {
      margin-left: 14px;
      margin-right: 12px;
      height: 40px;
    }
    // 按钮
    .operation_box {
      display: flex;
      margin: 14px 0px 20px 0px;
      width: 88px;
      height: 40px;
      opacity: 1;
      border-radius: 4px;
      ::v-deep .el-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 112px;
        height: 40px;
        background: #ebecf1;
        border-radius: 3px;
        letter-spacing: 1px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #000000;
        span {
          display: flex;
          align-items: center;
        }
        span > img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }
      }
    }
  }
}
.operation_box {
  ::v-deep .el-button--text {
    font-size: 16px;
    font-weight: 400;
    color: #ff0000;
    > span {
      padding-right: 8px;
    }
  }
}
</style>